<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
        <template slot="buttons">
       
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <DataFilter :gridId="gridId" :isExport="false"></DataFilter>
        <SlickGrid
          :gridId="gridId"
          :editable="false"
          :frozenColumn="2"
          :isAutoInitData="true"
          baseUrl="/Inbox"
        />

      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: helper.getWord('inbox'),
  access_code: "HOME_02",
  icon: "fas fa-envelope fa-fw",
  order: 1,
  components: {},
  data() {
    return {
      gridId: "list01",
      formData: {
        staff_name: ""
      },
    };
  },
  created() {
   this.$route.meta.access_code = "HOME";
    this.actionSetForceBlock(false);
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },
    mode() {
      return this.grid.mode;
    },
    dataList() {
      return this.grid.selectRows || [];
    }
   
  },
  mounted() {},
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),

  
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>